export const QUERY_KEYS = {
  userData: "userData",
  uadTaxonomy: "uadTaxonomy",
  appSettings: "appSettings",
  fleetInsurerDefaultSettings: "fleetInsurerDefaultSettings",
  fleetVehicleDefaultSettings: "fleetVehicleDefaultSettings",
  insurerSettings: "insurerSettings",
  insurerListSettings: "insurerListSettings",
  clientList: "clientList",
  insurerListByCountry: "insurerListByCountry",
  vehicleHistoryInformation: "vehicleHistoryInformation",
};

export const MUTATION_KEYS = {
  addAppSettings: "addAppSettings",
  updateAppSetting: "updateAppSetting",
  addFleetPremium: "addFleetPremium",
  adjustFleetDeductible: "adjustFleetDeductible",
  adjustFleet: "adjustFleet",
  changeFleetPaymentMethod: "changeFleetPaymentMethod",
  compareInsurerBookings: "compareInsurerBookings",
  createFleet: "createFleet",
  deleteAppSetting: "deleteAppSetting",
  deleteFleet: "deleteFleet",
  moveFleetToAnotherClient: "moveFleetToAnotherClient",
  duplicateFleet: "duplicateFleet",
  setFleetCancellationStatus: "setFleetCancellationStatus",
  deleteMultipleVehicles: "deleteMultipleVehicles",
  deleteVehicle: "deleteVehicle",
  generateFleetVehicleReport: "generateFleetVehicleReport",
  indexFleet: "indexFleet",
  updateFleetPremiumForEngineTax20250401:
    "updateFleetPremiumForEngineTax20250401",
  updateFleetPremiumDocumentDate: "updateFleetPremiumDocumentDate",
  recalculateFleetProRataAndBookings: "recalculateFleetProRataAndBookings",
  recalculateVehicleProRataAndBookings: "recalculateVehicleProRataAndBookings",
  cancelFleetPremium: "cancelFleetPremium",
  continueFleetPremium: "continueFleetPremium",
  deleteFleetPremium: "deleteFleetPremium",
  synchronizeFleetClient: "synchronizeFleetClient",
  synchronizeFleetInsurer: "synchronizeFleetInsurer",
  updateFleet: "updateFleet",
  updateBulkFleetPremium: "updateBulkFleetPremium",
  createFleetInsurerDefaultSetting: "createFleetInsurerDefaultSetting",
  updateFleetInsurerDefaultSetting: "updateFleetInsurerDefaultSetting",
  deleteFleetInsurerDefaultSetting: "deleteFleetInsurerDefaultSetting",
  updateFleetVehicleDefaultSetting: "updateFleetVehicleDefaultSetting",
  createFleetVehicleDefaultSetting: "createFleetVehicleDefaultSetting",
  deleteFleetVehicleDefaultSetting: "deleteFleetVehicleDefaultSetting",
  duplicateVehicleWithPremiums: "duplicateVehicleWithPremiums",
  changeVehicleStatus: "changeVehicleStatus",
  changeVehiclePolicyStatus: "changeVehiclePolicyStatus",
  changeVehicleIssuingStatus: "changeVehicleIssuingStatus",
  changeMultipleVehicleIssuingStatus: "changeMultipleVehicleIssuingStatus",
  changeMultipleVehiclePendingIssuingStatus:
    "changeMultipleVehiclePendingIssuingStatus",
  searchVehiclesForExcel: "searchVehiclesForExcel",
  updateVehicle: "updateFleet",
  updateTempVehicle: "updateTempVehicle",
  createVehicle: "createVehicle",
  createTradeLicensePlate: "createTradeLicensePlate",
  importScanDocument: "importScanDocument",
  createAttachment: "createAttachment",
  updateAttachment: "updateAttachment",
  removeAttachment: "removeAttachment",
  updateInsurerSettings: "updateInsurerSettings",
  createInsurerSettings: "createInsurerSettings",
  insertSharedLicensePlate: "insertSharedLicensePlate",
  cancelSharedLicensePlate: "cancelSharedLicensePlate",
  correctSharedLicensePlate: "correctSharedLicensePlate",
  deleteSharedLicensePlate: "deleteSharedLicensePlate",
  continueSharedLicensePlate: "continueSharedLicensePlate",
  activateSharedLicensePlate: "activateSharedLicensePlate",
  suspendSharedLicensePlate: "suspendSharedLicensePlate",
  insertVehiclePremium: "insertVehiclePremium",
  addVehiclePremium: "addVehiclePremium",
  switchVehicleHullPremiumType: "switchVehicleHullPremiumType",
  updatePremiumBookingIssuingStatus: "updatePremiumBookingIssuingStatus",
  updateVehiclePremiumBookingIssuingStatus:
    "updateVehiclePremiumBookingIssuingStatus",
  correctVehicleLicensePlate: "correctVehicleLicensePlate",
  insertVehicleLicensePlate: "insertVehicleLicensePlate",
  deleteVehicleLicensePlate: "deleteVehicleLicensePlate",
  changeVehicleLicensePlate: "changeVehicleLicensePlate",
  setVehicleLicensePlate: "setVehicleLicensePlate",
  setVehiclePremiumPolicyData: "setVehiclePremiumPolicyData",
  cancelVehicleFlottomatBusinessCase: "cancelVehicleFlottomatBusinessCase",
  insertVehicleOneTimePremium: "insertVehicleOneTimePremium",
  correctVehicleOneTimePremium: "correctVehicleOneTimePremium",
  deleteVehicleOneTimePremium: "deleteVehicleOneTimePremium",
  correctVehiclePremium: "correctVehiclePremium",
  correctLastVehiclePremium: "correctLastVehiclePremium",
  adjustVehiclePremium: "adjustVehiclePremium",
  cancelVehiclePremium: "cancelVehiclePremium",
  deleteVehiclePremium: "deleteVehiclePremium",
  continueVehiclePremium: "continueVehiclePremium",
  correctVehicleStatus: "correctVehicleStatus",
  correctVehiclePolicyStatus: "correctVehiclePolicyStatus",
  insertVehicleStatus: "insertVehicleStatus",
  deleteVehicleStatus: "deleteVehicleStatus",
  deleteVehiclePolicyStatus: "deleteVehiclePolicyStatus",
  cancelVehiclePendingStatus: "cancelVehiclePendingStatus",
  transferTEMPVehicle: "transferTEMPVehicle",
  deleteTEMPVehicle: "deleteTEMPVehicle",
  deleteMultipleTEMPVehicles: "deleteMultipleTEMPVehicles",
  approveVehiclePendingStatus: "approveVehiclePendingStatus",
  correctVehicleStatusDate: "correctVehicleStatusDate",
  confirmVehicleChanges: "confirmVehicleChanges",
  deleteInsurerSettings: "deleteInsurerSettings",
  deleteInsurerSetting: "deleteInsurerSetting",
  changeFleetPremiumDueDate: "changeFleetPremiumDueDate",
  uploadFleetVehicles: "uploadFleetVehicles",
  amendRiskProposal: "amendRiskProposal",
  amendRiskCheck: "amendRiskCheck",
  amendRiskExecute: "amendRiskExecute",
};
